import { useEffect, useState, ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface PageTransitionProps {
  children: ReactNode;
}

const PageTransition = ({ children }: PageTransitionProps) => {
  const location = useLocation();
  const [displayChildren, setDisplayChildren] = useState(children);
  const [stage, setStage] = useState<"enter" | "exit">("enter");

  useEffect(() => {
    if (children !== displayChildren) {
      setStage("exit");
      const timeout = setTimeout(() => {
        setDisplayChildren(children);
        setStage("enter");
        window.scrollTo(0, 0);
      }, 350);
      return () => clearTimeout(timeout);
    }
  }, [children, displayChildren]);

  return (
    <div
      className={`transition-opacity duration-350 ease-out ${
        stage === "enter" ? "opacity-100" : "opacity-0"
      }`}
      style={{ transitionDuration: "350ms" }}
    >
      {displayChildren}
    </div>
  );
};




export default PageTransition;
